<!-- Floating Action Button -->
@if (shouldShowFloatingButton) {
<button
  class="fab-button mm-text-white"
  mat-fab
  color="accent"
  disableRipple
  aria-label="Show Shift Metrics"
  (click)="toggleMetrics()"
  [disabled]="isLoading"
>
  @if (!isLoading) {
  <mat-icon>bar_chart</mat-icon>
  } @if (isLoading) {
  <mat-progress-spinner
    color="accent"
    diameter="24"
    mode="indeterminate"
  ></mat-progress-spinner>
  }
</button>
}

<!-- Floating Shift Metrics Card -->
<div class="floating-metrics" [class.visible]="showMetrics">
  <mat-card appearance="outlined" class="metrics-card">
    <mat-card-title class="metrics-title">
      <mat-icon class="pulse-icon">trending_up</mat-icon> Shift Metrics
    </mat-card-title>

    <table class="metrics-table">
      @for (item of metricsMapping; track item) {
      <tr>
        <td class="metric-label">{{ item.key }}</td>
        <td class="metric-value">{{ item.value }}</td>
      </tr>
      }
    </table>

    <button mat-icon-button class="close-btn" (click)="toggleMetrics()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card>
</div>
